<template>
    <div>
        <v-menu offset-y v-model="isMenuOpen" max-height="450">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="searchInput"
                    v-on="on"
                    v-bind="attrs"
                    @click:append="openDialogCliente()"
                    @input="isMenuOpen = true"
                    :append-icon="clienteId ? 'mdi-pencil' : ''"
                    :loading="searchLoading"
                    label="Cliente"
                    placeholder="Digite para pesquisar"
                    prepend-inner-icon="mdi-magnify"
                    class="mt-4 mb-2"
                    style="min-width: 200px;"
                    dense
                    clearable
                    outlined
                    hide-details
                />
            </template>
            <v-list>
                <template v-if="clientes.length">
                    <v-list-item
                        v-for="(cliente, index) in clientes"
                        :key="index"
                        @click="onSelect(cliente)"
                    >
                        <v-list-item-title>
                            {{ cliente.id }} - {{ cliente.nome }} {{ cliente.whatsapp ? ` - ${cliente.whatsapp}` : '' }}
                        </v-list-item-title>
                    </v-list-item>
                </template>
                <v-list-item v-else style="display: flex; justify-content: center;">
                    {{ !searchLoading && searchInput && !clientes.length ? 'Nenhum registro encontrado' : 'Pesquise pelo código, nome ou whatsapp' }}
                </v-list-item>

                <v-list-item>
                    <v-btn
                        @click="openDialogCliente('reset')"
                        color="primary"
                        class="mt-2"
                        block
                        small
                    >
                        <v-icon small>mdi-account</v-icon>
                        <span class="ml-2">
                            {{ !searchLoading && searchInput && !clientes.length ? `Cadastrar ${searchInput}` : 'Novo Cliente'}}
                        </span>
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-menu>

        <div
            v-if="value && (value.whatsapp || enderecoExibido)"
            class="mt-1 caption d-flex align-center"
            style="gap: 4px; overflow: hidden;"
        >
            <span v-if="value.whatsapp" style="flex-shrink: 0;">{{ value.whatsapp }}</span>
            <template v-if="enderecoExibido">
                <span v-if="value.whatsapp" style="flex-shrink: 0;">·</span>
                <span class="text-truncate" style="min-width: 0;">{{ truncar(enderecoExibido.texto) }}</span>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon x-small v-on="on" v-bind="attrs" style="flex-shrink: 0;">mdi-information-outline</v-icon>
                    </template>
                    <span>{{ tooltipEndereco }}</span>
                </v-tooltip>
            </template>
        </div>

        <Cliente
            :id="clienteId"
            :visible="dialogClienteVisible"
            :name="searchInput"
            @save="onSaveCliente"
            @close="closeDialogCliente"
        />
    </div>
</template>

<script>
import Cliente from '@/pages/cadastro/Cliente/Cliente.vue';

export default {
    name: 'PedidoSlider',

    components: {
        Cliente,
    },

    props: {
        value: {
            default: null,
        },
        // snapshot do endereço do pedido atual (passado pelo DialogComanda/PedidoSlider)
        pedidoEndereco: {
            type: Object,
            default: null,
        },
    },

    data: () => ({
        isMenuOpen: false,
        searchLoading: false,
        dialogClienteVisible: false,
        clientes: [],
        cliente: null,
        searchInput: null,
    }),

    mounted() {
        this.setClienteInList();
    },

    computed: {
        clienteId() {
            return this.value?.id || null;
        },

        // Endereço exibido após o whatsapp, por prioridade:
        // 1) snapshot do pedido atual; 2) snapshot do último pedido; senão null.
        enderecoExibido() {
            const p = this.pedidoEndereco;
            if (p && (p.rua || p.bairro || p.numero)) {
                return { texto: this.formatarEndereco(p), origem: 'pedido' };
            }

            const u = this.value?.ultimo_pedido_endereco;
            if (u && (u.rua || u.bairro || u.numero)) {
                return { texto: this.formatarEndereco(u), origem: 'ultimo' };
            }

            return null;
        },

        // texto completo (não truncado) + origem, exibido no tooltip do ícone (i)
        tooltipEndereco() {
            if (!this.enderecoExibido) {
                return '';
            }
            const label = this.enderecoExibido.origem === 'pedido'
                ? 'Endereço deste pedido'
                : 'Endereço do último pedido';
            return `${label}: ${this.enderecoExibido.texto}`;
        },
    },

    watch: {
        searchInput(v) {
            if (v === null) {
                this.reset();
                return;
            }

            this.startSearchTimer();
        },

        'value.id'(v) {
            v ? this.setClienteInList() : this.reset();
        },
    },

    methods: {
        setClienteInList() {
            if (!this.value?.id) {
                return;
            }

            this.onSelect(this.value);

            // const index = this.clientes.findIndex(c => c.id == this.value.id);
            // (index === -1) && this.clientes.push(this.value);

            // this.cliente = this.value;
            // this.setCliente(this.value);
        },

        onSelect(cliente) {
            if (!cliente) {
                return;
            }

            this.clientes = this.clientes.filter(e => e.id == cliente.id);

            this.$root.$emit('loading', true);
            this.$http.get(`clientes/${cliente.id}`).then(({ data }) => {
                this.setCliente(cliente);
                this.$emit('update', data);
            }).finally(() => this.$root.$emit('loading', false));
        },

        setCliente(cliente) {
            this.cliente = cliente;
            this.searchInput = `${cliente.id} - ${cliente.nome}`;
        },

        onSaveCliente(cliente) {
            this.reset();

            this.dialogClienteVisible = false;

            const index = this.clientes.findIndex(c => c.id === cliente.id);

            if (index !== -1) {
                this.clientes[index] = cliente;
            } else {
                this.clientes.push(cliente);
            }

            this.cliente = cliente;

            this.onSelect(cliente);
        },

        openDialogCliente(reset) {
            reset && this.$emit('reset');
            this.dialogClienteVisible = true;
        },

        closeDialogCliente() {
            this.dialogClienteVisible = false;
        },

        startSearchTimer() {
            const search = this.searchInput || '';
            if (search.length < 2) {
                this.clientes = [];
                return;
            }

            // clearTimeout(this.searchTimer);
            // this.searchTimer = setTimeout(this.performSearch, 1000);
            this.performSearch();
        },

        performSearch() {
            const search = this.searchInput || '';

            this.searchLoading = true;
            this.$http.post(`clientes/find?search=${search}`).then(resp => {
                this.clientes = resp.data;
            }).finally(() => (this.searchLoading = false));
        },

        reset() {
            this.clientes = [];
            this.cliente = null;
            this.searchInput = null;
            this.$emit('update', null);
        },

        formatarEndereco(e) {
            if (!e) {
                return '';
            }
            const linha = [e.rua, e.numero].filter(Boolean).join(', ');
            const bairroMun = [e.bairro, e.municipio].filter(Boolean).join(' - ');
            const compl = e.complemento || e.referencia;
            return [linha, bairroMun, compl].filter(Boolean).join(' · ');
        },

        truncar(str, max = 40) {
            const s = (str || '').toString();
            return s.length > max ? s.slice(0, max).trimEnd() + '...' : s;
        },
    },
}
</script>

<style scoped>
.v-list-item__title {
    height: 20px;
}

.v-list-item {
    height: 20px;
}
</style>
